import { useContext, useMemo } from 'react';
import { useFeatureFlagEnabled } from 'posthog-js/react';

import useSessionStore from '../../../../../hooks/useSessionStore';
import { FeatureFlag } from '../../../../../utils/postHog';
import { useCoachConfig } from '../../../../hooks/useCoachConfig';
import ExternalCoachContext from '../../../../context/ExternalCoachContext';
import feedType, {
  mainFeedTypes,
  footerFeedTypes,
} from '../../../../context/FeedContext/config/feedTypes';
import feedTypeConfig from '../../../../context/FeedContext/config/feedTypeConfig';
import FeedContext from '../../../../context/FeedContext';

const useFeedListConfig = () => {
  const { onFeedSelected, totalUnreadCount } = useContext(FeedContext);
  const { isCoachAssistant } = useSessionStore();
  const { externalCoachDoc } = useContext(ExternalCoachContext);
  const coachId = externalCoachDoc?.id;
  const isCoachTasksEnabled = useFeatureFlagEnabled(FeatureFlag.ENABLE_COACH_TASKS);

  const { coachConfig } = useCoachConfig(coachId);
  const isUserPreferenceChangeFeedEnabled = coachConfig?.shouldEnableTrackAutoAssignment !== false;

  const visibleMainFeedTypes = useMemo(() => (
    mainFeedTypes.filter((type) => {
      if (type === feedType.DISENGAGED_CLIENT) {
        return isCoachAssistant;
      }
      if (type === feedType.USER_PREFERENCE_CHANGE) {
        return isCoachAssistant && isUserPreferenceChangeFeedEnabled;
      }
      if (type === feedType.COACH_TASK) {
        return isCoachTasksEnabled;
      }
      if (type === feedType.WORKOUT_CONFLICT_REVIEW) {
        return isCoachAssistant;
      }
      return true;
    })
  ), [
    isCoachAssistant,
    isUserPreferenceChangeFeedEnabled,
    isCoachTasksEnabled,
  ]);

  const feedListEntries = visibleMainFeedTypes.map((type) => ({
    feedId: feedType[type],
    onClick: () => onFeedSelected(feedType[type]),
    icon: feedTypeConfig[feedType[type]].icon,
    unreadCount: totalUnreadCount[feedType[type]],
    title: feedTypeConfig[feedType[type]].title,
  }));

  const footerFeedListEntries = footerFeedTypes.map((type) => ({
    feedId: feedType[type],
    onClick: () => onFeedSelected(feedType[type]),
    icon: feedTypeConfig[feedType[type]].icon,
    unreadCount: totalUnreadCount[feedType[type]],
    title: feedTypeConfig[feedType[type]].title,
  }));

  return {
    feedListEntries,
    footerFeedListEntries,
  };
};

export default useFeedListConfig;
